import { Component, OnInit } from '@angular/core';

@Component({
  selector: ' cambiarsucursal-mmax-modal',
  templateUrl: './cambiarsucursal-mmax-modal.component.html',
  styleUrls: ['./cambiarsucursal-mmax-modal.component.scss']
})
export class CambiarsucursalMmaxModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
